import { NewslettersConfig } from "interfaces/form";
import { numbersRegex } from "utils/forms";
import { convertMillisToSeconds } from "utils/time";
import * as yup from "yup";

export const ANIMATION_DURATION_IN_MILLIS = 500;

export const ANIMATION_DURATION = `${convertMillisToSeconds(
  ANIMATION_DURATION_IN_MILLIS
)}s`;

export interface MessageFormValues extends NewslettersConfig {
  name: string;
  email: string;
  phone: string;
  message: string;
}

export const initialValues: MessageFormValues = {
  name: "",
  email: "",
  phone: "",
  message: "",
  privacyPolicy: false,
  newsletters: false,
};

export const validationSchema = (): yup.SchemaOf<MessageFormValues> =>
  yup.object().shape({
    name: yup.string().required(),
    email: yup.string().email().required(),
    phone: yup.string().matches(numbersRegex).required(),
    message: yup.string().required(),
    privacyPolicy: yup.bool().required().oneOf([true], " "),
    newsletters: yup.bool(),
  });
